import type { BaseDataItem, Spx } from '@wix/thunderbolt-becky-types'
import type { VariantRelationViewItem } from '@wix/thunderbolt-catharsis'

/**
 * TEMPORARY UTILITIES - copied from thunderbolt-catharsis-extensions to break circular dependency
 * TODO: Move these to @wix/thunderbolt-commons for shared use
 */

// Constants from catharsis-extensions/src/features/variables/constants.ts
export const DESKTOP_SPX: Spx = {
	refWidth: 1280,
	resolverType: 'scale'
}

export const MOBILE_SPX: Spx = {
	refWidth: 390,
	resolverType: 'scale'
}

// Utility from catharsis-extensions/src/utils/toBreakpointVariantsMap.ts
const isVariantRelation = <T extends BaseDataItem>(val: any): val is VariantRelationViewItem<T> => {
	return val && typeof val === 'object' && 'variants' in val && 'to' in val
}

export const getVariant = <TItem extends BaseDataItem>(val: VariantRelationViewItem<TItem> | TItem) => {
	if (!isVariantRelation(val)) {
		return { breakpointId: 'default', variantsKey: '', value: val }
	}

	const VARIANTS_SEPARATOR = '__'
	const seed = { breakpointId: 'default', variantsKey: '', value: val.to }
	return val.variants.reduce((acc, curr) => {
		if (curr.type === 'BreakpointRange') {
			// choose the first breakpoint
			acc.breakpointId = acc.breakpointId === 'default' ? curr.id : acc.breakpointId
		} else {
			acc.variantsKey = acc.variantsKey === '' ? curr.id : `${acc.variantsKey}${VARIANTS_SEPARATOR}${curr.id}`
		}
		return acc
	}, seed)
}

// Type from catharsis-extensions (you'll need to define this based on usage)
export type BreakpointsVariantsTo<T> = {
	[breakpointId: string]: {
		[variantsKey: string]: T
	}
}
